import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a0d1860"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请先去测试环境复制cookie", -1))
const _hoisted_3 = [
  _hoisted_2
]

import { useRoute } from 'vue-router';
// import { ref } from 'vue';
import { AppEnv } from '@/utils';
// import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
// const cookie = ref('');

const redirectUrl = encodeURI((route.query.redirectUrl as string) ?? window.location.origin);

if (AppEnv.isProduction || AppEnv.isTest) {
  window.open(
    `${process.env.VUE_APP_LOGOUT_HOST}/sso/sign/login?tenant=lingdong&side=employee&redirect_url=${redirectUrl}&app_id=cli_a5c6ed9bbfe1100c`,
    '_self'
  );
}
// const onClickSave = () => {
//   document.cookie = cookie.value;
//   window.open(redirectUrl, '_self');
// };

return (_ctx: any,_cache: any) => {
  return (_unref(AppEnv).isDevelopment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})